import { AxiosError } from 'axios';

export enum ApiErrorType {
  InvalidId = 'INVALID_ID',
  RecordDeleted = 'RECORD_DELETED',
  RecordArchived = 'RECORD_ARCHIVED',
  DuplicateAutomation = 'CONFLICTING_FIELD_VALUE',
}
interface BaseError {
  message: string;
}

interface InvalidIdError extends BaseError {
  code: 10000;
  type: ApiErrorType.InvalidId;
}

interface RecordDeletedError extends BaseError {
  code: 10001;
  type: ApiErrorType.RecordDeleted;
}

interface RecordArchivedError extends BaseError {
  code: 10001;
  type: ApiErrorType.RecordArchived;
  data: {
    canUnarchive: boolean;
    projectId: number;
    projectName: string;
  };
}

interface SalesforceDuplicateAutomationError extends BaseError {
  code: 10001;
  type: ApiErrorType.DuplicateAutomation;
}

type ErrorResponse =
  | InvalidIdError
  | RecordDeletedError
  | RecordArchivedError
  | SalesforceDuplicateAutomationError;

export type ApiErrorData = AxiosError<ErrorResponse>;

export type ArchivedProjectApiErrorData = AxiosError<RecordArchivedError>;
